import { Moon, Sun } from 'lucide-react';

import { cn } from '@/design-system/lib/cn';
import { THEME_COPY, useTheme } from '@/theme';

export type ThemeToggleProps = {
  /** `ghost` no cabeçalho; `outline` (com borda, sobre o branco) no login. */
  variant?: 'ghost' | 'outline';
  className?: string;
};

/** Botão que alterna o tema claro e o escuro: lua no claro, sol no escuro. */
export default function ThemeToggle({ variant = 'ghost', className }: ThemeToggleProps) {
  const { theme, toggle } = useTheme();
  const Icon = theme === 'dark' ? Sun : Moon;
  const label = THEME_COPY[theme].action;

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className={cn(
        'grid size-10 shrink-0 place-items-center rounded-control text-ink-secondary',
        variant === 'outline'
          ? 'border border-line-input bg-white hover:bg-surface-subtle'
          : 'hover:bg-header-hover',
        className
      )}
    >
      <Icon aria-hidden className="size-4.5 stroke-[1.8]" />
    </button>
  );
}
